import type { CSSProperties } from 'react'
import {
  createIconComponent,
  createSimpleIcon,
  createColorStrokeIcon,
  createColorFillIcon,
} from './icon-factories'
import type { IconProps } from './icon-factories'

import { ReactComponent as Bell } from 'assets/icons/bell.svg'
import { ReactComponent as Warehouse } from 'assets/icons/warehouse.svg'
import { ReactComponent as ProductionGray } from 'assets/icons/production-gray.svg'
import { ReactComponent as LogisticsGray } from 'assets/icons/logistics.svg'
import { ReactComponent as Supply } from 'assets/icons/supply.svg'
import { ReactComponent as Manifacturing } from 'assets/icons/manifacturing.svg'
import { ReactComponent as HomeBgIconCorner } from 'assets/icons/homeBackgroundIcon.svg'

import { ReactComponent as SmoothChart } from 'assets/icons/linesmoothchart.svg'
import { ReactComponent as LineChart } from 'assets/icons/linechart.svg'
import { ReactComponent as Settings } from 'assets/icons/settings.svg'
import { ReactComponent as LogoDefault } from 'assets/icons/logo-default.svg'
import { ReactComponent as LogoWhite } from 'assets/icons/logo-white.svg'
import { ReactComponent as CollapsedDots } from 'assets/icons/collapsedDots.svg'
import { ReactComponent as Infinite } from 'assets/icons/infinite.svg'
import { ReactComponent as ExclamationCircle } from 'assets/icons/exclamation-circle.svg'
import { ReactComponent as LeftArrow } from 'assets/icons/LeftArrow.svg'
import { ReactComponent as Menu } from 'assets/icons/menu.svg'
import { ReactComponent as AddProductShortcut } from 'assets/icons/add-product-shortcut.svg'
import { ReactComponent as ManageWarehouse } from 'assets/icons/manage-warehouse.svg'
import { ReactComponent as Avatar } from 'assets/icons/avatar.svg'
import { ReactComponent as Branches } from 'assets/icons/branches.svg'
import { ReactComponent as Edit } from 'assets/icons/edit.svg'
import { ReactComponent as DotsVertical } from 'assets/icons/dots-vertical.svg'
import { ReactComponent as Delete } from 'assets/icons/trash-delete.svg'
import { ReactComponent as UserAvatar } from 'assets/icons/user-avatar.svg'
import { ReactComponent as Printer } from 'assets/icons/printer.svg'
import { ReactComponent as Import } from 'assets/icons/import-file.svg'
import { ReactComponent as Export } from 'assets/icons/export-file.svg'
import { ReactComponent as Filter } from 'assets/icons/filter.svg'
import { ReactComponent as Plus } from 'assets/icons/plus.svg'
import { ReactComponent as Close } from 'assets/icons/close.svg'
import { ReactComponent as PlusBig } from 'assets/icons/plus-big.svg'
import { ReactComponent as MinusBig } from 'assets/icons/minus.svg'
import { ReactComponent as Copy } from 'assets/icons/copy.svg'
import { ReactComponent as Generate } from 'assets/icons/generate.svg'

import { ReactComponent as Eye } from 'assets/icons/eye.svg'
import { ReactComponent as ViewEye } from 'assets/icons/view-eye.svg'
import { ReactComponent as Calculator } from 'assets/icons/calculator.svg'

import { ReactComponent as EyeSlash } from 'assets/icons/eye-slash.svg'
import { ReactComponent as ChevronLeft } from 'assets/icons/chevron-left.svg'
import { ReactComponent as ChevronRight } from 'assets/icons/chevron-right.svg'
import { ReactComponent as Upload } from 'assets/icons/upload-icon.svg'
import { ReactComponent as SearchBarcode } from 'assets/icons/search-barcode-icon.svg'
import { ReactComponent as SearchBarcodeWhite } from 'assets/icons/search-barcode-icon-white.svg'
import { ReactComponent as IncomeProduct } from 'assets/icons/coming.svg'
import { ReactComponent as ComingWhite } from 'assets/icons/coming-white.svg'
import { ReactComponent as SchedulingWhite } from 'assets/icons/scheduling-white.svg'
import { ReactComponent as PieChart } from 'assets/icons/pie-chart.svg'
import { ReactComponent as Clouds } from 'assets/icons/clouds.svg'
import { ReactComponent as Warehouse2 } from 'assets/icons/warehouse2.svg'
import { ReactComponent as Materials2 } from 'assets/icons/materials2.svg'
import { ReactComponent as ArrowRightMini } from 'assets/icons/mini-chavron-right.svg'
import { ReactComponent as Bell2 } from 'assets/icons/bell2.svg'
import { ReactComponent as ExtendMessage } from 'assets/icons/extend-message.svg'
import { ReactComponent as InfoCircle } from 'assets/icons/InfoCircle.svg'
import { ReactComponent as FileMini } from 'assets/icons/file-mini.svg'
import { ReactComponent as WarehouseManagement } from 'assets/icons/warehouse-management.svg'
import { ReactComponent as Preference } from 'assets/icons/preference.svg'
import { ReactComponent as Actions } from 'assets/icons/actions.svg'
import { ReactComponent as Books } from 'assets/icons/books.svg'
import { ReactComponent as Materials } from 'assets/icons/materials.svg'
import { ReactComponent as ParentCategory } from 'assets/icons/Sisternode.svg'
import { ReactComponent as List } from 'assets/icons/list.svg'
import { ReactComponent as Gallery } from 'assets/icons/galary-view.svg'
import { ReactComponent as Download } from 'assets/icons/Download.svg'
import { ReactComponent as Upload2 } from 'assets/icons/Upload.svg'
import { ReactComponent as PaperClip } from 'assets/icons/PaperClip.svg'
import { ReactComponent as Tick } from 'assets/icons/tickIcon.svg'
import { ReactComponent as EmptyFolder } from 'assets/icons/folder-no-file.svg'
import { ReactComponent as IncomingDocs } from 'assets/icons/incoming_docs.svg'
import { ReactComponent as Signature1 } from 'assets/icons/signature1.svg'
import { ReactComponent as Password } from 'assets/icons/password_icon.svg'
import { ReactComponent as Login } from 'assets/icons/login_icon.svg'
import { ReactComponent as GlassProLogo } from 'assets/icons/glassProLogo.svg'
import { ReactComponent as GlassPro } from 'assets/icons/glassPro.svg'
import { ReactComponent as IncomeDocsDark } from 'assets/icons/income-docs-dark.svg'
import { ReactComponent as CloudsDark } from 'assets/icons/Clouds-dark.svg'
import { ReactComponent as WarehouseDark } from 'assets/icons/warehouse-dark.svg'
import { ReactComponent as SupplyDark } from 'assets/icons/supply-dark.svg'
import { ReactComponent as GateDark } from 'assets/icons/gate-dark.svg'
import { ReactComponent as Gate } from 'assets/icons/gate.svg'
import { ReactComponent as GateAwaiting } from 'assets/icons/awaiting.svg'
import { ReactComponent as GateInspecting } from 'assets/icons/checking.svg'
import { ReactComponent as GateHistory } from 'assets/icons/history.svg'
import { ReactComponent as AccountingDark } from 'assets/icons/accounting-dark.svg'
import { ReactComponent as Accounting } from 'assets/icons/accounting.svg'
import { ReactComponent as LogoGlassPro } from 'assets/icons/logoGlasPro.svg'
import { ReactComponent as Skripka } from 'assets/icons/skripka.svg'
import { ReactComponent as ClockCircle } from 'assets/icons/ClockCircle.svg'
import { ReactComponent as ShieldOff } from 'assets/icons/shildOff.svg'
import { ReactComponent as ShieldOn } from 'assets/icons/shildOn.svg'
import { ReactComponent as Refresh } from 'assets/icons/refresh.svg'
import { ReactComponent as ImageIc } from 'assets/icons/imageIcon.svg'
import { ReactComponent as Fund } from 'assets/icons/fund.svg'
import { ReactComponent as CustomPayment } from 'assets/icons/custom-payment.svg'
import { ReactComponent as ExpensexColored } from 'assets/icons/expensex-colored.svg'
import { ReactComponent as NdsColored } from 'assets/icons/nds-colored.svg'
import { ReactComponent as CategoryOrder } from 'assets/icons/category-order.svg'
import { ReactComponent as Category } from 'assets/icons/category.svg'
import { ReactComponent as Clients } from 'assets/icons/clients.svg'
import { ReactComponent as Company } from 'assets/icons/company.svg'
import { ReactComponent as Departments } from 'assets/icons/department.svg'
import { ReactComponent as Employee } from 'assets/icons/employee.svg'
import { ReactComponent as District } from 'assets/icons/districts.svg'
import { ReactComponent as Region } from 'assets/icons/regions.svg'
import { ReactComponent as DocType } from 'assets/icons/doc-type.svg'
import { ReactComponent as ExpenseManage } from 'assets/icons/expense-manage.svg'
import { ReactComponent as Incomes } from 'assets/icons/incomes.svg'
import { ReactComponent as Inventory } from 'assets/icons/inventory.svg'
import { ReactComponent as MeasureUnit } from 'assets/icons/measure-unit.svg'
import { ReactComponent as MeasureWidthHeight } from 'assets/icons/measure-width-height.svg'
import { ReactComponent as Notification } from 'assets/icons/notification.svg'
import { ReactComponent as Orders } from 'assets/icons/orders.svg'
import { ReactComponent as Permits } from 'assets/icons/permits.svg'
import { ReactComponent as RequestManage } from 'assets/icons/request-manage.svg'
import { ReactComponent as Position } from 'assets/icons/position.svg'
import { ReactComponent as Pricing } from 'assets/icons/pricing.svg'
import { ReactComponent as Roles } from 'assets/icons/roles.svg'
import { ReactComponent as Transport } from 'assets/icons/transport.svg'
import { ReactComponent as TransportationInvoice } from 'assets/icons/transportation-invoice.svg'
import { ReactComponent as Vehicle } from 'assets/icons/vehical.svg'
import { ReactComponent as WarehouseForMenu } from 'assets/icons/warehouse-for-menu.svg'
import { ReactComponent as WindowThickness } from 'assets/icons/window-thickness.svg'
import { ReactComponent as Percentage } from 'assets/icons/Percentage.svg'
import { ReactComponent as Logout } from 'assets/icons/logout.svg'
import { ReactComponent as Telegram } from 'assets/icons/telegram.svg'
import { ReactComponent as ExpandView } from 'assets/icons/expand-view.svg'
import { ReactComponent as ErrorFallback } from 'assets/icons/error-fallback.svg'
import { ReactComponent as StagingCompleted } from 'assets/icons/stage-completed.svg'
import { ReactComponent as StagingNew } from 'assets/icons/stage-new.svg'
import { ReactComponent as StagingTransporting } from 'assets/icons/stage-transporting.svg'
import { ReactComponent as StagingConfirmed } from 'assets/icons/stage-confirmed.svg'
import { ReactComponent as StagingProblem } from 'assets/icons/stage-deley.svg'
import { ReactComponent as IncomeCompleted } from 'assets/icons/income-completed.svg'
import { ReactComponent as IncomeWaiting } from 'assets/icons/income-waiting.svg'
import { ReactComponent as IncomeUnloading } from 'assets/icons/income-unloading.svg'
import { ReactComponent as IncomeProblem } from 'assets/icons/income-problem.svg'
import { ReactComponent as ReadyProduct } from 'assets/icons/ready-product.svg'
import { ReactComponent as Sash } from 'assets/icons/sash.svg'
import { ReactComponent as MaterialsIcons } from 'assets/icons/materiaals.svg'
import { ReactComponent as ModelIcon } from 'assets/icons/models.svg'
import { ReactComponent as ServicesIcon } from 'assets/icons/services-icon.svg'
import { ReactComponent as FilesIcon } from 'assets/icons/files.svg'
import { ReactComponent as DoorHandleHorizontal } from 'assets/icons/doorHandleHorizontal.svg'
import { ReactComponent as VerticalHandles } from 'assets/icons/vertical-handles.svg'
import { ReactComponent as ServicePrice } from 'assets/icons/service-price.svg'
import { ReactComponent as Sales } from 'assets/icons/sales-department.svg'
import { ReactComponent as Save } from 'assets/icons/save-line.svg'
import { ReactComponent as GalaryView } from 'assets/icons/galary-view.svg'
import { ReactComponent as ListView } from 'assets/icons/list-view.svg'
import { ReactComponent as Users } from 'assets/icons/users.svg'
import { ReactComponent as DoubleChecked } from 'assets/icons/doubleChecked.svg'

// --- Factory-created icons ---

const EditIcon = createIconComponent(Edit, 'EditIcon', { cursor: 'pointer' })
const UsersIcon = createIconComponent(Users, 'UsersIcon', { cursor: 'pointer' })
const ViewEyeIcon = createIconComponent(ViewEye, 'ViewEyeIcon', { cursor: 'pointer' })
const SalesIcon = createSimpleIcon(Sales, 'SalesIcon')
const UploadIcon = createIconComponent(Upload, 'UploadIcon', { cursor: 'pointer' })
const Upload2Icon = createIconComponent(Upload2, 'Upload2Icon', {
  cursor: 'pointer',
  colorTarget: 'fill',
})
const PaperClipIcon = createIconComponent(PaperClip, 'PaperClipIcon', {
  cursor: 'pointer',
  colorTarget: 'fill',
})
const DownloadIcon = createIconComponent(Download, 'DownloadIcon', {
  cursor: 'pointer',
  colorTarget: 'fill',
})
const GalleryIcon = createIconComponent(Gallery, 'GalleryIcon', { cursor: 'pointer' })
const ListIcon = createIconComponent(List, 'ListIcon', { cursor: 'pointer' })
const GeneratorIcon = createIconComponent(Generate, 'GeneratorIcon', { cursor: 'pointer' })
const PrinterIcon = createIconComponent(Printer, 'PrinterIcon', { cursor: 'pointer' })
const ImportIcon = createIconComponent(Import, 'ImportIcon', { cursor: 'pointer' })
const ExportIcon = createIconComponent(Export, 'ExportIcon', { cursor: 'pointer' })
const FilterIcon = createIconComponent(Filter, 'FilterIcon', { cursor: 'pointer' })
const GalaryViewIcon = createIconComponent(GalaryView, 'GalaryViewIcon', { cursor: 'pointer' })
const ListViewIcon = createIconComponent(ListView, 'ListViewIcon', { cursor: 'pointer' })
const PlusIcon = createIconComponent(Plus, 'PlusIcon', { cursor: 'pointer' })
const CloseIcon = createIconComponent(Close, 'CloseIcon', { cursor: 'pointer' })
const PlusBigIcon = createIconComponent(PlusBig, 'PlusBigIcon', {
  cursor: 'pointer',
  colorTarget: 'fill',
})
const MinusBigIcon = createIconComponent(MinusBig, 'MinusBigIcon', { cursor: 'pointer' })
const FileMiniIcon = createIconComponent(FileMini, 'FileMiniIcon', { cursor: 'pointer' })
const DotsVerticalIcon = createIconComponent(DotsVertical, 'DotsVerticalIcon', {
  cursor: 'pointer',
})
const BellIcon = createIconComponent(Bell, 'BellIcon', { cursor: 'pointer' })

const IncomeWaitingIcon = createSimpleIcon(IncomeWaiting, 'IncomeWaitingIcon')
const IncomeUnloadingIcon = createSimpleIcon(IncomeUnloading, 'IncomeUnloadingIcon')
const IncomeCompletedIcon = createSimpleIcon(IncomeCompleted, 'IncomeCompletedIcon')
const IncomeProblemIcon = createSimpleIcon(IncomeProblem, 'IncomeProblemIcon')
const StagingNewIcon = createSimpleIcon(StagingNew, 'StagingNewIcon')
const StagingTransportingIcon = createSimpleIcon(StagingTransporting, 'StagingTransportingIcon')
const StagingConfirmedIcon = createSimpleIcon(StagingConfirmed, 'StagingConfirmedIcon')
const StagingCompletedIcon = createSimpleIcon(StagingCompleted, 'StagingCompletedIcon')
const ReadyProductIcon = createSimpleIcon(ReadyProduct, 'ReadyProductIcon')

const MaterialsSegmentedIcon = createSimpleIcon(MaterialsIcons, 'MaterialsSegmentedIcon')
const ModelsSegmentedIcon = createSimpleIcon(ModelIcon, 'ModelsSegmentedIcon')
const ServicesSegmentedIcon = createSimpleIcon(ServicesIcon, 'ServicesSegmentedIcon')
const FilesSegmentedIcon = createSimpleIcon(FilesIcon, 'FilesSegmentedIcon')
const StagingProblemIcon = createSimpleIcon(StagingProblem, 'StagingProblemIcon')

const WarehouseIcon = createSimpleIcon(Warehouse, 'WarehouseIcon')
const LogoGlassProIcon = createSimpleIcon(LogoGlassPro, 'LogoGlassProIcon', { cursor: 'pointer' })
const WarehouseDarkIcon = createSimpleIcon(WarehouseDark, 'WarehouseDarkIcon')
const CloudsDarkIcon = createSimpleIcon(CloudsDark, 'CloudsDarkIcon')
const IncomeDocsDarkIcon = createSimpleIcon(IncomeDocsDark, 'IncomeDocsDarkIcon')
const SupplyDarkIcon = createSimpleIcon(SupplyDark, 'SupplyDarkIcon', { cursor: 'pointer' })
const GateDarkIcon = createSimpleIcon(GateDark, 'GateDarkIcon')
const GateIcon = createSimpleIcon(Gate, 'GateIcon')
const GateAwaitingIcon = createColorStrokeIcon(GateAwaiting, 'GateAwaitingIcon')
const GateInspectingIcon = createColorStrokeIcon(GateInspecting, 'GateInspectingIcon')
const GateHistoryIcon = createColorStrokeIcon(GateHistory, 'GateHistoryIcon')
const AccountingDarkIcon = createSimpleIcon(AccountingDark, 'AccountingDarkIcon')
const AccountingIcon = createSimpleIcon(Accounting, 'AccountingIcon')
const ProductionGrayIcon = createSimpleIcon(ProductionGray, 'ProductionGrayIcon')
const LogisticsGrayIcon = createSimpleIcon(LogisticsGray, 'LogisticsGrayIcon')

const EmptyFolderIcon = createSimpleIcon(EmptyFolder, 'EmptyFolderIcon', { cursor: 'pointer' })
const SupplyIcon = createSimpleIcon(Supply, 'SupplyIcon', { cursor: 'pointer' })
const LeftArrowIcon = createSimpleIcon(LeftArrow, 'LeftArrowIcon', { cursor: 'pointer' })
const MenuIcon = createSimpleIcon(Menu, 'MenuIcon', { cursor: 'pointer' })
const LoginIcon = createSimpleIcon(Login, 'LoginIcon', { cursor: 'pointer' })
const GlassProLogoIcon = createSimpleIcon(GlassProLogo, 'GlassProLogoIcon', { cursor: 'pointer' })
const GlassProIcon = createSimpleIcon(GlassPro, 'GlassProIcon', { cursor: 'pointer' })
const PasswordIcon = createSimpleIcon(Password, 'PasswordIcon', { cursor: 'pointer' })
const AddProductShortcutIcon = createSimpleIcon(AddProductShortcut, 'AddProductShortcutIcon')
const ClockCircleIcon = createSimpleIcon(ClockCircle, 'ClockCircleIcon')
const IncomeProductIcon = createSimpleIcon(IncomeProduct, 'IncomeProductIcon')
const IncomeProductWhiteIcon = createSimpleIcon(ComingWhite, 'IncomeProductWhiteIcon')
const SchedulingWhiteIcon = createSimpleIcon(SchedulingWhite, 'SchedulingWhiteIcon')
const PreferenceIcon = createSimpleIcon(Preference, 'PreferenceIcon')
const FundIcon = createSimpleIcon(Fund, 'FundIcon')
const WarehouseManagementIcon = createSimpleIcon(WarehouseManagement, 'WarehouseManagementIcon')

const CategoryIcon = createColorStrokeIcon(Category, 'CategoryIcon')
const CategoryOrderIcon = createColorStrokeIcon(CategoryOrder, 'CategoryOrderIcon')
const MeasureUnitIcon = createColorStrokeIcon(MeasureUnit, 'MeasureUnitIcon')
const MeasureWidthHeightIcon = createColorStrokeIcon(MeasureWidthHeight, 'MeasureWidthHeightIcon')
const WindowThicknessIcon = createColorStrokeIcon(WindowThickness, 'WindowThicknessIcon')
const PercentageIcon = createColorFillIcon(Percentage, 'PercentageIcon')
const InventoryIcon = createColorStrokeIcon(Inventory, 'InventoryIcon')
const DocTypeIcon = createColorStrokeIcon(DocType, 'DocTypeIcon')
const TelegramIcon = createColorStrokeIcon(Telegram, 'TelegramIcon')
const ExpandViewIcon = createColorStrokeIcon(ExpandView, 'ExpandViewIcon')
const CompanyIcon = createColorStrokeIcon(Company, 'CompanyIcon')
const ClientsIcon = createColorStrokeIcon(Clients, 'ClientsIcon')
const RolesIcon = createColorStrokeIcon(Roles, 'RolesIcon')
const PositionIcon = createColorStrokeIcon(Position, 'PositionIcon')
const EmployeeIcon = createColorStrokeIcon(Employee, 'EmployeeIcon')
const RegionIcon = createColorStrokeIcon(Region, 'RegionIcon')
const DistrictIcon = createColorStrokeIcon(District, 'DistrictIcon')
const WarehouseForMenuIcon = createColorStrokeIcon(WarehouseForMenu, 'WarehouseForMenuIcon')
const DepartmentsIcon = createColorStrokeIcon(Departments, 'DepartmentsIcon')
const TransportIcon = createColorStrokeIcon(Transport, 'TransportIcon')
const NotificationIcon = createColorStrokeIcon(Notification, 'NotificationIcon')
const RequestManageIcon = createColorStrokeIcon(RequestManage, 'RequestManageIcon')
const OrdersIcon = createColorStrokeIcon(Orders, 'OrdersIcon')
const PermitsIcon = createColorStrokeIcon(Permits, 'PermitsIcon')
const TransportationInvoiceIcon = createColorStrokeIcon(
  TransportationInvoice,
  'TransportationInvoiceIcon',
)
const PricingIcon = createColorStrokeIcon(Pricing, 'PricingIcon')
const IncomesIcon = createColorStrokeIcon(Incomes, 'IncomesIcon')
const ExpenseManageIcon = createColorStrokeIcon(ExpenseManage, 'ExpenseManageIcon')
const VehicleIcon = createColorStrokeIcon(Vehicle, 'VehicleIcon')

const CustomPaymentIcon = createSimpleIcon(CustomPayment, 'CustomPaymentIcon')
const ExpensexColoredIcon = createSimpleIcon(ExpensexColored, 'ExpensexColoredIcon')
const NdsColoredIcon = createSimpleIcon(NdsColored, 'NdsColoredIcon')

const ActionsIcon = createSimpleIcon(Actions, 'ActionsIcon')
const BooksIcon = createSimpleIcon(Books, 'BooksIcon')
const PieChartIcon = createSimpleIcon(PieChart, 'PieChartIcon')
const MaterialsIcon = createSimpleIcon(Materials, 'MaterialsIcon')
const ErrorFallbackIcon = createSimpleIcon(ErrorFallback, 'ErrorFallbackIcon')
const ParentCategoryIcon = createSimpleIcon(ParentCategory, 'ParentCategoryIcon')

const AvatarIcon = createSimpleIcon(Avatar, 'AvatarIcon')
const CalculatorIcon = createSimpleIcon(Calculator, 'CalculatorIcon')
const BranchesIcon = createSimpleIcon(Branches, 'BranchesIcon')
const ManageWarehouseIcon = createSimpleIcon(ManageWarehouse, 'ManageWarehouseIcon')
const ManifacturingIcon = createSimpleIcon(Manifacturing, 'ManifacturingIcon', {
  cursor: 'pointer',
})
const SmoothChartIcon = createSimpleIcon(SmoothChart, 'SmoothChartIcon')
const LineChartIcon = createSimpleIcon(LineChart, 'LineChartIcon')

const InfiniteIcon = createSimpleIcon(Infinite, 'InfiniteIcon', { cursor: 'pointer' })
const CollapsedDotsIcon = createSimpleIcon(CollapsedDots, 'CollapsedDotsIcon', {
  cursor: 'pointer',
})
const CloudsIcon = createSimpleIcon(Clouds, 'CloudsIcon')
const Bell2Icon = createSimpleIcon(Bell2, 'Bell2Icon')
const ExtendMessageIcon = createSimpleIcon(ExtendMessage, 'ExtendMessageIcon')
const SashIcon = createSimpleIcon(Sash, 'SashIcon', { cursor: 'pointer' })

// --- Custom inline icons (ref-as-prop, no forwardRef) ---

const EyeSlashIcon = ({ ref, eye, className, style, ...props }: IconProps & { eye?: string }) => (
  <EyeSlash
    ref={ref}
    className={className}
    style={{
      width: eye === 'true' ? '0px' : '15px',
      cursor: 'pointer',
      height: '15px',
      transition: 'all 0.2s ease',
      ...style,
    }}
    {...props}
  />
)
EyeSlashIcon.displayName = 'EyeSlashIcon'

const EyeIcon = ({ ref, eye, className, style, ...props }: IconProps & { eye?: string }) => (
  <Eye
    ref={ref}
    className={className}
    style={{
      width: eye === 'true' ? '15px' : '0px',
      cursor: 'pointer',
      height: '15px',
      transition: 'all 0.2s ease',
      ...style,
    }}
    {...props}
  />
)
EyeIcon.displayName = 'EyeIcon'

const DoorHandleHorizontalIcon = ({
  ref,
  top,
  left,
  color,
  className,
  style,
  ...props
}: IconProps & { top?: string; left?: string }) => (
  <DoorHandleHorizontal
    ref={ref}
    className={`${color ? '[&_path]:stroke-(--icon-color) [&_path]:fill-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        position: 'absolute' as const,
        top: top || '0',
        left: left || '0',
        cursor: 'pointer',
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
DoorHandleHorizontalIcon.displayName = 'DoorHandleHorizontalIcon'

const VerticalHandlesIcon = ({
  ref,
  width,
  height,
  top,
  left,
  right,
  bottom,
  positionRTF,
  color,
  className,
  style,
  ...props
}: IconProps & {
  top?: string
  left?: string
  right?: string
  bottom?: string
  positionRTF?: string
}) => (
  <VerticalHandles
    ref={ref}
    className={`${color ? '[&_path]:fill-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || '40px',
        height: height || '131px',
        position: 'absolute' as const,
        top: top || 'unset',
        left: positionRTF === 'left' ? left : 'unset',
        right: positionRTF === 'right' ? right : 'unset',
        bottom: bottom || 'unset',
        cursor: 'pointer',
        zIndex: 6,
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
VerticalHandlesIcon.displayName = 'VerticalHandlesIcon'

const SaveIcon = ({
  ref,
  width,
  height,
  color,
  hovercolor,
  cursor,
  transition,
  className,
  style,
  ...props
}: IconProps & { transition?: string }) => (
  <Save
    ref={ref}
    className={className}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        cursor: cursor || 'pointer',
        height: height || 'var(--appTableIconSize)',
        transition: transition || 'all 0.2s ease',
        color: color || 'var(--appIconDefaultColor)',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
SaveIcon.displayName = 'SaveIcon'

const CopyIcon = ({
  ref,
  copied,
  className,
  style,
  ...props
}: IconProps & { copied?: boolean }) => (
  <Copy
    ref={ref}
    className={`[&_path]:fill-(--icon-color) hover:[&_path]:fill-(--icon-hover-color) ${className || ''}`}
    style={
      {
        position: 'absolute' as const,
        top: '-3px',
        right: '10px',
        width: '15px',
        cursor: 'pointer',
        height: '40px',
        zIndex: 3,
        transition: 'all 0.2s ease',
        '--icon-color': copied ? '#fff' : '#444',
        '--icon-hover-color': copied ? '#fff' : '#46a9ff',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
CopyIcon.displayName = 'CopyIcon'

const Signature1Icon = ({ ref, width, height, color, className, style, ...props }: IconProps) => (
  <Signature1
    ref={ref}
    className={className}
    style={{
      width: width || 'var(--appTableIconSize)',
      height: height || 'var(--appTableIconSize)',
      color: color || 'var(--appIconDefaultColor)',
      ...style,
    }}
    {...props}
  />
)
Signature1Icon.displayName = 'Signature1Icon'

const ChevronLeftIcon = ({
  ref,
  width,
  height,
  color,
  hovercolor,
  margin,
  rotate,
  className,
  style,
  ...props
}: IconProps & { rotate?: number | string }) => (
  <ChevronLeft
    ref={ref}
    className={`[&_path]:stroke-(--icon-color) ${hovercolor ? 'hover:[&_path]:stroke-(--icon-hover-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        cursor: 'pointer',
        margin: margin || undefined,
        '--icon-color': color || 'var(--back-btn-white)',
        '--icon-hover-color': hovercolor || 'var(--back-btn-black)',
        transform: rotate ? `rotate(${rotate}deg)` : 'none',
        transition: 'transform 0.2s ease',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
ChevronLeftIcon.displayName = 'ChevronLeftIcon'

const DoubleCheckedIcon = ({
  ref,
  width,
  height,
  color,
  hovercolor,
  margin,
  rotate,
  className,
  style,
  ...props
}: IconProps & { rotate?: number | string }) => (
  <DoubleChecked
    ref={ref}
    className={`[&_path]:stroke-(--icon-color) ${hovercolor ? 'hover:[&_path]:stroke-(--icon-hover-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        cursor: 'pointer',
        margin: margin || undefined,
        '--icon-color': color || 'var(--back-btn-white)',
        '--icon-hover-color': hovercolor || 'var(--back-btn-black)',
        transform: rotate ? `rotate(${rotate}deg)` : 'none',
        transition: 'transform 0.2s ease',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
DoubleCheckedIcon.displayName = 'DoubleCheckedIcon'

const ChevronRightIcon = ({
  ref,
  width,
  height,
  color,
  hovercolor,
  margin,
  rotate,
  className,
  style,
  ...props
}: IconProps & { rotate?: number | string }) => (
  <ChevronRight
    ref={ref}
    className={`[&_path]:stroke-(--icon-color) ${hovercolor ? 'hover:[&_path]:stroke-(--icon-hover-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        cursor: 'pointer',
        margin: margin || undefined,
        '--icon-color': color || 'var(--back-btn-white)',
        '--icon-hover-color': hovercolor || 'var(--back-btn-black)',
        transform: rotate ? `rotate(${rotate}deg)` : 'none',
        transition: 'transform 0.2s ease',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
ChevronRightIcon.displayName = 'ChevronRightIcon'

const DeleteIcon = ({
  ref,
  position,
  top,
  right,
  left,
  bottom,
  width,
  height,
  color,
  hovercolor,
  margin,
  className,
  style,
  ...props
}: IconProps & {
  position?: string
  top?: string
  right?: string
  left?: string
  bottom?: string
}) => (
  <Delete
    ref={ref}
    className={`[&_path]:stroke-(--icon-color) ${hovercolor ? 'hover:[&_path]:stroke-(--icon-hover-color)' : ''} ${className || ''}`}
    style={
      {
        position: (position || 'relative') as CSSProperties['position'],
        top: top || 'unset',
        right: right || 'unset',
        left: left || 'unset',
        bottom: bottom || 'unset',
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        cursor: 'pointer',
        margin: margin || undefined,
        '--icon-color': color || 'var(--appIconDefaultColor)',
        '--icon-hover-color': hovercolor || 'var(--appIconDefaultColor)',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
DeleteIcon.displayName = 'DeleteIcon'

const ExclamationCircleIcon = ({
  ref,
  width,
  height,
  color,
  className,
  style,
  ...props
}: IconProps) => (
  <ExclamationCircle
    ref={ref}
    className={`${color ? '[&_path]:fill-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
ExclamationCircleIcon.displayName = 'ExclamationCircleIcon'

const ServicePriceIcon = ({ ref, width, height, color, className, style, ...props }: IconProps) => (
  <ServicePrice
    ref={ref}
    className={`${color ? '[&_path]:fill-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
ServicePriceIcon.displayName = 'ServicePriceIcon'

const SkripkaIcon = ({ ref, width, height, className, style, ...props }: IconProps) => (
  <Skripka
    ref={ref}
    className={className}
    style={{
      width: width || '12px',
      height: height || '12px',
      ...style,
    }}
    {...props}
  />
)
SkripkaIcon.displayName = 'SkripkaIcon'

const TickIcon = ({ ref, width, height, margin, className, style, ...props }: IconProps) => (
  <Tick
    ref={ref}
    className={`[&_path]:stroke-(--icon-color) ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        cursor: 'pointer',
        margin: margin || undefined,
        '--icon-color': 'green',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
TickIcon.displayName = 'TickIcon'

const ImageIcon = ({ ref, width, height, color, className, style, ...props }: IconProps) => (
  <ImageIc
    ref={ref}
    className={`[&_path]:stroke-(--icon-color) ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        '--icon-color': color || '#1A1C3B',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
ImageIcon.displayName = 'ImageIcon'

const RefreshIcon = ({
  ref,
  width,
  height,
  color,
  rotate,
  className,
  style,
  ...props
}: IconProps & { rotate?: number | string }) => (
  <Refresh
    ref={ref}
    className={`[&_path]:stroke-(--icon-color) ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        '--icon-color': color || 'var(--appIconDefaultColor)',
        cursor: 'pointer',
        transform: rotate ? `rotate(${rotate}deg)` : undefined,
        transition: 'all 0.2s ease',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
RefreshIcon.displayName = 'RefreshIcon'

const LogoutIcon = ({ ref, width, height, color, className, style, ...props }: IconProps) => (
  <Logout
    ref={ref}
    className={`${color ? '[&_path]:stroke-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
LogoutIcon.displayName = 'LogoutIcon'

const InfoCircleIcon = ({
  ref,
  width,
  height,
  color,
  hovercolor,
  className,
  style,
  ...props
}: IconProps) => (
  <InfoCircle
    ref={ref}
    className={`${color ? '[&_path]:fill-(--icon-color)' : ''} ${hovercolor ? 'hover:[&_path]:fill-(--icon-hover-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        cursor: 'pointer',
        '--icon-color': color || undefined,
        '--icon-hover-color': hovercolor || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
InfoCircleIcon.displayName = 'InfoCircleIcon'

const SearchBarcodeIcon = ({
  ref,
  width,
  height,
  color,
  className,
  style,
  ...props
}: IconProps) => (
  <SearchBarcode
    ref={ref}
    className={`${color ? '[&_path]:fill-(--icon-color) [&_rect]:fill-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: 'auto',
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
SearchBarcodeIcon.displayName = 'SearchBarcodeIcon'

const Warehouse2Icon = ({ ref, width, height, color, className, style, ...props }: IconProps) => (
  <Warehouse2
    ref={ref}
    className={`${color ? '[&_path]:stroke-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: 'auto',
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
Warehouse2Icon.displayName = 'Warehouse2Icon'

const Materials2Icon = ({ ref, width, height, color, className, style, ...props }: IconProps) => (
  <Materials2
    ref={ref}
    className={`[&_path]:stroke-(--icon-color) ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: 'auto',
        '--icon-color': color || 'var(--appIconDefaultColor)',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
Materials2Icon.displayName = 'Materials2Icon'

const ArrowRightIcon = ({
  ref,
  width,
  height,
  color,
  rotate,
  className,
  style,
  ...props
}: IconProps & { rotate?: number | string }) => (
  <ArrowRightMini
    ref={ref}
    className={`${color ? '[&_path]:stroke-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: 'auto',
        '--icon-color': color || undefined,
        transform: rotate ? `rotate(${rotate}deg)` : undefined,
        transition: 'all 0.2s ease',
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
ArrowRightIcon.displayName = 'ArrowRightIcon'

const SearchBarcodeWhiteIcon = ({
  ref,
  width,
  height,
  color,
  className,
  style,
  ...props
}: IconProps) => (
  <SearchBarcodeWhite
    ref={ref}
    className={`${color ? '[&_path]:fill-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: 'auto',
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
SearchBarcodeWhiteIcon.displayName = 'SearchBarcodeWhiteIcon'

const IncomingDocsIcon = ({ ref, width, height, className, style, ...props }: IconProps) => (
  <IncomingDocs
    ref={ref}
    className={className}
    style={{
      width: width || '60px',
      height: height || '60px',
      ...style,
    }}
    {...props}
  />
)
IncomingDocsIcon.displayName = 'IncomingDocsIcon'

const UserAvatarIcon = ({ ref, width, height, color, className, style, ...props }: IconProps) => (
  <UserAvatar
    ref={ref}
    className={`${color ? '[&_path]:stroke-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
UserAvatarIcon.displayName = 'UserAvatarIcon'

const SettingsIcon = ({
  ref,
  width,
  height,
  color,
  margin,
  className,
  style,
  ...props
}: IconProps) => (
  <Settings
    ref={ref}
    className={`${color ? '[&_path]:stroke-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || 'var(--appTableIconSize)',
        height: height || 'var(--appTableIconSize)',
        margin: margin || undefined,
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
SettingsIcon.displayName = 'SettingsIcon'

const LogoDefaultIcon = ({ ref, width, height, margin, className, style, ...props }: IconProps) => (
  <LogoDefault
    ref={ref}
    className={className}
    style={{
      width: width || undefined,
      height: height || undefined,
      margin: margin || undefined,
      ...style,
    }}
    {...props}
  />
)
LogoDefaultIcon.displayName = 'LogoDefaultIcon'

const LogoWhiteIcon = ({ ref, width, height, margin, className, style, ...props }: IconProps) => (
  <LogoWhite
    ref={ref}
    className={className}
    style={{
      width: width || undefined,
      height: height || undefined,
      margin: margin || undefined,
      ...style,
    }}
    {...props}
  />
)
LogoWhiteIcon.displayName = 'LogoWhiteIcon'

const HomeBgIconCornerBottom = ({ ref, className, style, ...props }: IconProps) => (
  <HomeBgIconCorner ref={ref} className={className} style={style} {...props} />
)
HomeBgIconCornerBottom.displayName = 'HomeBgIconCornerBottom'

const LogoPreLoader = ({ ref, className, style, ...props }: IconProps) => (
  <LogoDefault
    ref={ref}
    className={`logo-preloader ${className || ''}`}
    style={{
      width: '100px',
      height: 'auto',
      ...style,
    }}
    {...props}
  />
)
LogoPreLoader.displayName = 'LogoPreLoader'

const ShieldOffIcon = ({ ref, width, height, className, style, ...props }: IconProps) => (
  <ShieldOff
    ref={ref}
    className={className}
    style={{
      width: width || '14px',
      height: height || '14px',
      ...style,
    }}
    {...props}
  />
)
ShieldOffIcon.displayName = 'ShieldOffIcon'

const ShieldOnIcon = ({ ref, width, height, color, className, style, ...props }: IconProps) => (
  <ShieldOn
    ref={ref}
    className={`${color ? '[&_path]:stroke-(--icon-color)' : ''} ${className || ''}`}
    style={
      {
        width: width || '14px',
        height: height || '14px',
        '--icon-color': color || undefined,
        ...style,
      } as CSSProperties
    }
    {...props}
  />
)
ShieldOnIcon.displayName = 'ShieldOnIcon'

export type { IconProps }

export {
  BellIcon,
  WarehouseIcon,
  SupplyIcon,
  ManifacturingIcon,
  HomeBgIconCornerBottom,
  SmoothChartIcon,
  LineChartIcon,
  SettingsIcon,
  LogoDefaultIcon,
  InfiniteIcon,
  CollapsedDotsIcon,
  ExclamationCircleIcon,
  LogoPreLoader,
  LeftArrowIcon,
  LogoWhiteIcon,
  MenuIcon,
  AddProductShortcutIcon,
  ManageWarehouseIcon,
  AvatarIcon,
  BranchesIcon,
  EditIcon,
  DeleteIcon,
  DotsVerticalIcon,
  UserAvatarIcon,
  PrinterIcon,
  ImportIcon,
  ExportIcon,
  FilterIcon,
  PlusIcon,
  CopyIcon,
  GeneratorIcon,
  EyeSlashIcon,
  EyeIcon,
  ChevronLeftIcon,
  ChevronRightIcon,
  UploadIcon,
  SearchBarcodeIcon,
  IncomeProductIcon,
  PieChartIcon,
  SearchBarcodeWhiteIcon,
  IncomeProductWhiteIcon,
  SchedulingWhiteIcon,
  CloudsIcon,
  Warehouse2Icon,
  Materials2Icon,
  ArrowRightIcon,
  Bell2Icon,
  ExtendMessageIcon,
  InfoCircleIcon,
  FileMiniIcon,
  PlusBigIcon,
  CloseIcon,
  ProductionGrayIcon,
  LogisticsGrayIcon,
  WarehouseManagementIcon,
  PreferenceIcon,
  ActionsIcon,
  BooksIcon,
  MaterialsIcon,
  CalculatorIcon,
  ParentCategoryIcon,
  GalleryIcon,
  ListIcon,
  DownloadIcon,
  Upload2Icon,
  PaperClipIcon,
  TickIcon,
  EmptyFolderIcon,
  MinusBigIcon,
  IncomingDocsIcon,
  Signature1Icon,
  LoginIcon,
  GlassProLogoIcon,
  PasswordIcon,
  GlassProIcon,
  WarehouseDarkIcon,
  CloudsDarkIcon,
  IncomeDocsDarkIcon,
  SupplyDarkIcon,
  GateDarkIcon,
  GateIcon,
  GateAwaitingIcon,
  GateInspectingIcon,
  GateHistoryIcon,
  AccountingDarkIcon,
  AccountingIcon,
  LogoGlassProIcon,
  SkripkaIcon,
  ClockCircleIcon,
  ShieldOffIcon,
  ShieldOnIcon,
  RefreshIcon,
  ImageIcon,
  FundIcon,
  CustomPaymentIcon,
  ExpensexColoredIcon,
  NdsColoredIcon,
  RolesIcon,
  PositionIcon,
  EmployeeIcon,
  RegionIcon,
  DistrictIcon,
  WarehouseForMenuIcon,
  DepartmentsIcon,
  TransportIcon,
  NotificationIcon,
  RequestManageIcon,
  OrdersIcon,
  PermitsIcon,
  TransportationInvoiceIcon,
  IncomesIcon,
  ExpenseManageIcon,
  VehicleIcon,
  CategoryIcon,
  CategoryOrderIcon,
  MeasureUnitIcon,
  MeasureWidthHeightIcon,
  WindowThicknessIcon,
  InventoryIcon,
  DocTypeIcon,
  CompanyIcon,
  ClientsIcon,
  PricingIcon,
  PercentageIcon,
  LogoutIcon,
  TelegramIcon,
  ExpandViewIcon,
  ErrorFallbackIcon,
  IncomeWaitingIcon,
  IncomeUnloadingIcon,
  IncomeCompletedIcon,
  IncomeProblemIcon,
  StagingNewIcon,
  StagingTransportingIcon,
  StagingConfirmedIcon,
  StagingCompletedIcon,
  StagingProblemIcon,
  ReadyProductIcon,
  ViewEyeIcon,
  SashIcon,
  MaterialsSegmentedIcon,
  ModelsSegmentedIcon,
  ServicesSegmentedIcon,
  FilesSegmentedIcon,
  DoorHandleHorizontalIcon,
  VerticalHandlesIcon,
  ServicePriceIcon,
  SalesIcon,
  SaveIcon,
  GalaryViewIcon,
  ListViewIcon,
  UsersIcon,
  DoubleCheckedIcon,
}
